export const getUserName = (user) => {
  const names = user.name.split(' ');
  let userName = names[0];

  if (names.length > 1) userName += ` ${names[1]}`;

  return userName;
};
